import {Divider, Input, Modal, Radio, Space} from "antd";
import React, {useState} from "react";
import FilterButton from "../../piece/FilterButton";
import {DollarOutlined} from "@ant-design/icons";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [minPriceFilter, setMinPriceFilter] = useState(null)
    const [maxPriceFilter, setMaxPriceFilter] = useState(null)

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <DollarOutlined/>
                Price Range
            </FilterButton>
            <Modal
                title='Price Range Filter'
                open={visible}
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            minPriceFilter: {
                                text: 'Min Price($)',
                                value: minPriceFilter
                            },
                            maxPriceFilter: {
                                text: 'Max Price($)',
                                value: maxPriceFilter
                            }
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
            >
                <Radio.Group
                    onChange={(e) => {
                        switch (e.target.value) {
                            case 1:
                                setMinPriceFilter(1)
                                setMaxPriceFilter(500)
                                break
                            case 2:
                                setMinPriceFilter(500)
                                setMaxPriceFilter(1000)
                                break
                            case 3:
                                setMinPriceFilter(1000)
                                setMaxPriceFilter(2000)
                                break
                            case 4:
                                setMinPriceFilter(2000)
                                setMaxPriceFilter(5000)
                                break
                            case 5:
                                setMinPriceFilter(5000)
                                setMaxPriceFilter(10000000)
                                break
                        }
                    }}
                >
                    <Space direction='vertical'>
                        <Radio value={1}>＜$500</Radio>
                        <Radio value={2}>$500 - $1,000</Radio>
                        <Radio value={3}>$1,000 - $2,000</Radio>
                        <Radio value={4}>$2,000 - $5,000</Radio>
                        <Radio value={5}>＞$5,000</Radio>
                    </Space>
                </Radio.Group>
                <Divider/>
                <Input
                    allowClear={true}
                    placeholder='Please input minimum filterable price ($), ex.1200'
                    onChange={(e) => {
                        setMinPriceFilter(e.target.value)
                    }}
                />
                <Input
                    placeholder='Please input maximum filterable price'
                    style={{marginTop: '16px'}}
                    onChange={(e) => {
                        setMaxPriceFilter(e.target.value)
                    }}
                />
            </Modal>
        </>
    )
}